import { GridItem } from "../../plugins/box-widget/models/grid-item.model";
import { GridLayout } from "../../plugins/box-widget/models/grid-layout.model";
import { pipe, groupBy, prop, toPairs, filter } from 'ramda';
import { isArray } from "ramda-adjunct";

/* eslint-disable */

export const defaultGridLayout = {
  columnNumber: 60,
  rowHeight: 6,
  isDraggable: true,
  isResizable: true,
  isMirrored: false,
  verticalCompact: true,
  margin: [10, 10],
  useCssTransforms: true,
};

export const defaultGridItem = {
  isResizable: true,
  minimized: false,
  selected: false,
  x: 0,
  y: 0,
  w: 30,
  origH: 30,
  h: 30,
  i: 'Grid Item',
  position: 'absolute',
  zIndex: 1,
};

// export const createGridItem = ({
//   isResizable   = true          ,
//   isDraggable   = false          ,
//   isPinnable    = true          ,
//   dragAllowFrom = '.box-header' ,
//   minimized     = false         ,
//   selected      = false         ,
//   x             = 0             ,
//   y             = 0             ,
//   w             = 30            ,
//   h             = 30            ,
//   i             = 'Grid Item'   ,
//   position      = 'absolute'    ,
//   zIndex        = 1             ,
//   transform     = ''            ,
//   oldTransform  = ''            ,
//   pinnedCoords  = {x: 0, y : 0} ,
//   isPinned      = false        ,
//   isStatic      = false        ,
// }) => {
//   return new GridItem(
//     {
//       isResizable,
//       isDraggable,
//       isPinnable,
//       dragAllowFrom,
//       minimized,
//       selected,
//       x,
//       y,
//       w,
//       h,
//       i,
//       position,
//       zIndex,
//       transform,
//       oldTransform,
//       pinnedCoords,
//       isPinned,
//       isStatic,
//     }
//   );
// };

export const getGridItemId = (id) => `VGI_${id}`

export const createGridItem = ({
  isResizable = false,
  isDraggable = false,
  isPinnable = true,
  dragAllowFrom = '.box-header',
  minimized = false,
  selected = false,
  x = 0,
  y = 0,
  w = 30,
  h = 30,
  i = 'Grid Item',
  position = 'absolute',
  zIndex = 1,
  transform = '',
  oldTransform = '',
  pinnedCoords = { x: 0, y: 0 },
  isPinned = false,
  expandState = false,
}) => {
  let collapsedHeight = 0;
  let expandedHeight = 0;

  if (isArray(h)) {
    collapsedHeight = h[0];
    expandedHeight = h[1];
    h = expandState ? expandedHeight : collapsedHeight;
  }

  const origH = h;
  const origW = w;
  const id = getGridItemId(i);

  return {
    id,
    isResizable,
    isDraggable,
    isPinnable,
    dragAllowFrom,
    minimized,
    selected,
    x,
    y,
    w,
    origH,
    h,
    i,
    position,
    zIndex,
    // transform, // Used for DBox Pin Mechanism
    // oldTransform,
    get class() {
      return {
        'selected': this.selected,
        'minimized': this.minimized
      };
    },
    get style() {
      return {
        'overflow': this.minimized ? 'hidden' : 'auto',
        'position': this.position,
        'zIndex': this.zIndex,
      }
    },
    pinnedCoords,
    isPinned,
    origW,

    expandState,
    collapsedHeight,
    expandedHeight,

    static: false
  };
};

export const createGridItemGetter = (gridLayout = createGridLayout()) => id => {
  return gridLayout.layout.find(item => item.id === getGridItemId(id));
}

export const createGridLayout = ({
  columnNumber = 60,
  rowHeight = 6,
  isDraggable = true,
  isResizable = true,
  isMirrored = false,
  verticalCompact = true,
  margin = [10, 10],
  useCssTransforms = true,
  layout = [createGridItem()]
}) => {

  const duplicates = pipe(groupBy(prop('id')), toPairs, filter(e => e[1].length > 1))(layout);

  if (duplicates.length > 0) {
    throw Error(`Check the Grid item with these Ids. These are duplicates -${duplicates.map(d => d[0])}`);
  }

  return {
    columnNumber,
    rowHeight,
    isDraggable,
    isResizable,
    isMirrored,
    verticalCompact,
    margin,
    useCssTransforms,
    layout,
  };
};

export const getGridItemClass = (gridItem) => {
  return {
    'selected': gridItem.selected,
    'minimized': gridItem.minimized
  };
};


export const updateTransform = (x, y, z = 0) => {
  return `translate3d(${x}px, ${y}px, ${z}px)`
}

const GridItemFunctions = {
  applyPinnedStyle: (elState) => {
    mutate(elState, {
      isPinned: true,
      isDraggable: false,
      zIndex: 2,
    });
  },
  applyUnpinnedStyle: (elState) => {
    mutate(elState, {
      isPinned: false,
      isDraggable: true,
      zIndex: 1,
    });
  },
  makeAbsolutePosition: (elState) => {
    if (!elState.isPinned) {
      mutate(elState, {
        ...elState,
        position: 'absolute',
      });
    }
  },
  makeFixedPosition: (elState) => {
    if (elState.isPinned) {
      mutate(elState, {
        ...elState,
        position: 'fixed',
      });
    }
  }
}


const mutate = (obj, mutation) => {
  for (const key in mutation) {
    obj[key] = mutation[key];
  }
}